module.exports = __webpack_public_path__ + "static/img/rage.76c526a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/rage.png
// module id = yI3D
// module chunks = 0